<script>
import { HorizontalBar } from 'vue-chartjs'

const colors = [
  '#25A4DF', // Blue
  '#44B469', // Green
  '#9AAEB9', // Gray
  '#E46651', // Red
  '#00D8FF', // Light Blue
  '#F87979', // Reddish Pink
  '#66D7D1', // Teal
  '#E6B89C', // Peach
  '#EAD2AC', // Tan
  '#9CAFB7', // Gray
  '#4281A4', // Dark Greenish-Blue
  '#C9683B', // Orange
  '#431B35', // Purple
  '#EF6461', // Pastel Red
  '#E4B363', // Earth Yellow
  '#313638', // Onyx
  '#5ADBFF', // Maya Blue
  '#FE9000', // Dark Orange
  '#466060', // Deep Space Sparkle
  '#0E0F19', // Smoky Black
  '#CBF7ED', // Aero Blue
  '#23395B', // Japanese Indigo
  '#CDE7B0', // Tea Green
  '#EF476F', // Infra Red
  '#26547C', // B'dazzled Blue
  '#1C3738', // Medium Jungle Green
  '#4C3957', // Pineapple (not pineapple)
  '#C68866', // Pale Copper
  '#F5F749', // Lemon yellow
  '#565554', // Davy's Grey
  '#F24236', // Vermilion
  '#84BCDA', // Dark Sky Blue
  '#F37748', // Mandarin
  '#7F7EFF', // Medium Slate Blue
  '#C69DD2', // Wisteria
  '#CC8B8C', // Puce
  '#593837', // Dark Liver (horses) -> Why on earth is this horse specific?
  '#CCC9E7' // Soap
]

export default {
  extends: HorizontalBar,
  props: ['chartName', 'apiData', 'fieldData', 'valueField', 'transformKeyFunction', 'barPercentage', 'maxBarThickness', 'categoryPercentage'],
  computed: {
    values: function () {
      let datasetObject = {}
      let datasetData = []
      let datasetColors = []

      this.apiData.forEach((value, index) => {
        const strVal = (this.apiData[index] && this.apiData[index].value)
          ? this.apiData[index].value.toString()
          : ''
        datasetData.push(strVal)
        datasetColors.push(colors[index % 37])
      })

      datasetObject = {
        data: datasetData,
        backgroundColor: datasetColors
      }

      return datasetObject
    },
    labels: function () {
      let labels = []
      this.apiData.forEach((value, index) => {
        const fieldName = this.transformKeyFunction ? this.transformKeyFunction(value.field) : value.field
        labels.push(fieldName)
      })

      return labels
    }
  },
  methods: {
    renderBarChart: function () {
      const opts = {
        legend: {
          display: false
        }
      }

      if (this.barPercentage || this.categoryPercentage || this.maxBarThickness || this.height) {
        const scalesOpts = {}
        if (this.barPercentage) {
          scalesOpts['barPercentage'] = this.barPercentage
        }
        if (this.categoryPercentage) {
          scalesOpts['categoryPercentage'] = this.categoryPercentage
        }
        if (this.maxBarThickness) {
          scalesOpts['maxBarThickness'] = this.maxBarThickness
        }
        if (this.height) {
          scalesOpts['height'] = this.height
        }

        opts.scales = {
          yAxes: [scalesOpts]
        }
      }

      this.renderChart(
        // data
        {
          labels: this.labels,
          datasets: [this.values]
        },
        opts
      )
    }
  },
  watch: {
    apiData: function () {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.renderBarChart()
    }
  },
  mounted () {
    this.renderBarChart()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/charts/HorizontalBarChart.vue